import { Directive, ElementRef, Renderer2, OnDestroy, Input, OnChanges, SimpleChanges, input, output } from '@angular/core';

@Directive({
  selector: '[appClickOutside]',
  standalone: true
})
export class ClickOutsideDirective implements OnDestroy, OnChanges {
  isActive = input<boolean>(true);

  readonly clickOutside = output<void>();
  private clickListener: () => void = () => {};

  constructor(private elementRef: ElementRef, private renderer: Renderer2) {}

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['isActive']) {
      if (this.isActive()) {
        this.addClickListener();
      } else {
        this.removeClickListener();
      }
    }
  }

  ngOnDestroy(): void {
    this.removeClickListener();
  }

  private addClickListener(): void {
    this.clickListener = this.renderer.listen('document', 'click', (event: Event) => {
      this.onDocumentClick(event);
    });
  }

  private removeClickListener(): void {
    if (this.clickListener) {
      this.clickListener();
      this.clickListener = () => {};
    }
  }

  private onDocumentClick(event: Event): void {
    const target = event.target as HTMLElement;
    if (target.closest('mat-select') || target.closest('mat-option')) {
      return;
    }
    if (!this.elementRef.nativeElement.contains(target)) {
      this.clickOutside.emit();
    }
  }
}